import { Component } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { BrandingService } from '@next/core-lib/branding';
import { LocaleService } from '@next/core-lib/i18n';
import { NavigationActions } from '@next/core-lib/navigation';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  private readonly isAgravis = this.brandingService.isTenant('Agravis');

  private readonly navigationItems$ = this.store.pipe(
    select(AuthorizationSelectors.hasGlobalAdministratorRole),
    map((isGlobalAdministrator) => [
      ...this.navigationItems,
      ...(isGlobalAdministrator ? this.globalAdministratorNavigationItems : []),
    ]),
  );
  private readonly navigationItems = [
    {
      relativeUrl: '/information',
      label: this.localService.translate('information'),
      icon: 'help',
    },
    {
      relativeUrl: '/profile',
      label: this.localService.translate('profile'),
      icon: 'supervised_user_circle',
    },
    ...(this.isAgravis
      ? []
      : [
          {
            relativeUrl: '/labresults',
            label: this.localService.translate('labresults'),
            icon: 'format_list_bulleted',
          },
          {
            relativeUrl: '/business-partner-backoffice',
            label: this.localService.translate('businessPartnerBackoffice'),
            icon: 'location_on',
          },
        ]),
  ];
  private readonly globalAdministratorNavigationItems = [
    {
      relativeUrl: '/developer-tools',
      label: this.localService.translate('jwt_token'),
      icon: 'developer_mode',
    },
    {
      relativeUrl: '/developer-auth',
      label: this.localService.translate('dev_api_tool'),
      icon: 'security',
    },
    {
      relativeUrl: '/app-wizard',
      label: this.localService.translate('app_wizard'),
      icon: 'cloud_done',
    },
  ];
  constructor(
    private readonly brandingService: BrandingService,
    private readonly localService: LocaleService,
    private readonly store: Store<RootState>,
  ) {
    this.navigationItems$.subscribe((navigationItems) => {
      this.store.dispatch(NavigationActions.setNavigationItems({ navigationItems }));
    });
  }
}
